var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    rx: 10,
    fill: "#464646"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 31C37 34.31 34.31 37 31 37V35.5C33.5 35.5 35.5 33.5 35.5 31H37ZM15 21C15 17.69 17.69 15 21 15V16.5C18.5 16.5 16.5 18.5 16.5 21H15ZM22 18.32L17.41 22.92C14.19 26.14 14.19 31.37 17.41 34.59C20.63 37.81 25.86 37.81 29.08 34.59L36.15 27.5C36.64 27.03 36.64 26.24 36.15 25.75C36.0339 25.6336 35.8959 25.5412 35.7441 25.4782C35.5922 25.4152 35.4294 25.3828 35.265 25.3828C35.1006 25.3828 34.9378 25.4152 34.7859 25.4782C34.634 25.5412 34.4961 25.6336 34.38 25.75L29.96 30.17L29.25 29.46L35.79 22.92C36.28 22.43 36.28 21.64 35.79 21.15C35.3 20.66 34.5 20.66 34 21.15L28.19 27L27.5 26.27L34.37 19.38C34.86 18.89 34.86 18.1 34.37 17.61C33.88 17.12 33.09 17.12 32.6 17.61L25.71 24.5L25 23.8L30.5 18.32C31 17.83 31 17.04 30.5 16.55C30 16.06 29.22 16.06 28.73 16.55L21.11 24.17C21.7073 24.9394 22.0033 25.9002 21.9425 26.8723C21.8818 27.8444 21.4684 28.761 20.78 29.45L20.07 28.74C20.6318 28.1775 20.9474 27.415 20.9474 26.62C20.9474 25.825 20.6318 25.0625 20.07 24.5L19.72 24.15L23.79 20.08C24.28 19.59 24.28 18.8 23.79 18.31C23.29 17.83 22.5 17.83 22 18.32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.ded29f9b6940f0a14ef50c266975a9ca.svg";
export { ForwardRef as ReactComponent };